<div mat-dialog-title>
  <h2 translate [translateParams]="{user: username}">{{title}}</h2>
  <button mat-dialog-close
    class="close"
    aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  @for (view of views; track view) {
    <app-dynamic [room]="view.room" [subject]="view.subject" [params]="view.params"></app-dynamic>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @for (actionButton of actionsButton; track actionButton) {
    <app-dynamic [room]="actionButton.room" [subject]="actionButton.subject" [params]="actionButton.params">
    </app-dynamic>
  }
</mat-dialog-actions>